import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

import { getRcsSuggestedActionsSchema } from "./rcsSuggestedActionsSchema";
import type { RcsSuggestedActionSchemaOptions } from ".";

export function getRcsSuggestionSchemaSchemaErrorStrings(
  t: I18nT<"rcs-composer">
): RcsSuggestedActionSchemaOptions["errorStrings"] {
  return {
    minActionsError: t("min-suggestions-error", "At least { minActions, number } suggestion is required", {
      minActions: sharedConstants.RCS.VALIDATIONS.MIN_NUMBER_SUGGESTED_ACTIONS,
    }),
    maxActionsError: t("max-suggestions-error", "{ maxActions, number }/{maxActions, number} suggestions added", {
      maxActions: sharedConstants.RCS.VALIDATIONS.MAX_NUMBER_SUGGESTED_ACTIONS,
    }),
    actionTypeRequired: t("rcs-suggested-action-type-required", "Action type is required"),
    actionTextRequired: t("rcs-suggested-action-text-required", "Suggestion text is required"),
    actionTextLengthError: t(
      "rcs-suggested-action-text-length-error",
      "Text must be { maxTextLength, number } characters or fewer",
      {
        maxTextLength: sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_TEXT_SUGGESTION,
      }
    ),
    actionUrlLengthError: t(
      "rcs-suggested-action-url-length-error",
      "Website URL must be {maxUrlLength, number} characters or fewer",
      {
        maxUrlLength: sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_URL_SUGGESTION,
      }
    ),
    actionUrlRequired: t("rcs-suggested-action-url-required", "Website URL is required"),
    actionUrlInvalidError: t("rcs-suggested-action-website-url-invalid-error", "Website URL is invalid"),
  };
}

export const getRcsSuggestionSchema = (t: I18nT<"rcs-composer">) =>
  getRcsSuggestedActionsSchema(t, {
    minActions: sharedConstants.RCS.VALIDATIONS.MIN_NUMBER_SUGGESTED_ACTIONS,
    maxActions: sharedConstants.RCS.VALIDATIONS.MAX_NUMBER_SUGGESTED_ACTIONS,
    errorStrings: getRcsSuggestionSchemaSchemaErrorStrings(t),
  });
